import BlockTitle from '@App/components/layout/BlockTitle';
import PropTypes from 'prop-types';
import Query from '@App/components/api/Query';
import GetMe from '@App/api/query/GetMe.graphql';
import { redirectToProfileSubscription } from '@App/routes';
import useAuth from '@App/common/hooks/useAuth';
import CountryNotAllowed from '@App/components/page/error/CountryNotAllowed';
import HyperlinePlanGrid from '@App/components/page/account/HyperlinePlanGrid';
import HubspotMeetings from '@App/components/hubspot/HubspotMeetings';

/**
 * Booking page of the sales team, as HubSpot hands its embed URL out. Hosted on support.miooz.com,
 * not on the www domain the other HubSpot links are built from, so it is written in full.
 */
const SALES_MEETING_URL = 'https://support.miooz.com/meetings/antoine-marquaille/rencontrer-equipe-commerciale?embed=true';

SubscriptionTable.propTypes = {
    profile: PropTypes.shape({
        id: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        isCoveredByOrganizationSubscription: PropTypes.bool,
        subscription: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }),
    }),
};

function SubscriptionTable({ profile }) {
    const { permissions } = useAuth();

    // Nobody who already has a plan is shown the plans: neither the customer who bought one, nor the
    // member whose company did. Both are sent to the account page, which says what they hold — and
    // for the member, who to call. Selling them a second plan is exactly the confusion this avoids.
    if (profile.subscription || profile.isCoveredByOrganizationSubscription) {
        redirectToProfileSubscription();

        return null;
    }

    if (!permissions.isInAllowedCountry) {
        return <CountryNotAllowed />;
    }

    return <div className="content page-subscription">
        <div className="container-fluid">
            <BlockTitle title="Nos abonnements pour les indépendants & les professionnels"/>
            <p className="text-center page-subscription__intro">
                Accédez à la plus grande librairie de musique à l’image française.
                {' '}<em>Écoutez, sélectionnez, synchronisez</em> tous vos projets audiovisuels.
            </p>

            <HyperlinePlanGrid />

            {/* Second route to the sales team, next to the quote card: the visitor whose need does not
                fit a plan should not have to work out which of the three cards to click. */}
            <section className="page-subscription__contact">
                <h2>Discutons de votre projet</h2>
                <p>
                    Besoin d’un plan sur mesure pour votre entreprise, ou d’une licence unitaire pour
                    la pub, cinéma, flux et TV. Parlons-en.
                </p>
                <HubspotMeetings src={SALES_MEETING_URL} />
            </section>
        </div>
    </div>;
}

export default function SubscriptionTableQuery() {
    return <Query component={SubscriptionTable} query={GetMe} mapResult={data => ({ profile: data.me })}/>;
}
